/// Puts a dash in if the passed in string is empty
function dashForEmpty(string) {
    if (string == null || string == "") {
        return "-";
    } else {
        return string;
    }
}

function setPageTitle(title) {
    let label = document.getElementById("PageHeadingTitle");
    if (label) {
        label.innerHTML = "";
        let txt = document.createTextNode(title);
        label.appendChild(txt);
    }
}


export {
    dashForEmpty,
    setPageTitle
}

